// src/components/fields/InputCountrySADC.jsx //
import React from "react";
import { AFRIMED_MARKETS } from "@/config/markets.js";
import MarketCountryPicker from "@/components/markets/MarketCountryPicker.jsx";
import { useLanguage } from "@/contexts/LanguageContext.jsx";

function findMarketIsoByName(name) {
  return (
    AFRIMED_MARKETS.find((market) => market.name === name)?.iso || ""
  );
}

export default function InputCountrySADC({
  label,
  value = "",
  onChange,
  tone = "auth",
  placeholderFlagIso = "za",
  useTextFieldTrigger = false,
  disabled = false,
}) {
  const { t } = useLanguage();
  return (
    <MarketCountryPicker
      label={label ?? t("fields.country.label", "Country")}
      value={findMarketIsoByName(value)}
      placeholder={t("fields.country.placeholder", "Select country")}
      searchPlaceholder={t("fields.country.searchPlaceholder", "Search countries")}
      tone={tone}
      placeholderFlagIso={placeholderFlagIso}
      useTextFieldTrigger={useTextFieldTrigger}
      disabled={disabled}
      onChange={(market) => onChange?.(market?.name || "")}
    />
  );
}
